import React, { useContext } from 'react'
import { Responsive } from 'responsive-react'
import { Row } from 'react-bootstrap'
import WithholdingCard from './WithholdingCard'
import WithholdingsListContext from './WithholdingsListContext'

const SmallScreen = () => {
  const { withholdings, highlightId } = useContext(WithholdingsListContext)

  return (
    <Responsive displayIn={['Mobile', 'Tablet']}>
      <Row>
        {withholdings.map(withholding => (
          <WithholdingCard
            key={withholding.Id}
            withholding={withholding}
            highlighted={Boolean(highlightId && withholding.Id === highlightId)}
          />
        ))}
      </Row>
    </Responsive>
  )
}

export default SmallScreen
